import {
  CANCELACION_SUCCESS,
  CANCELACION_LOADING,
  CANCELACION_ERROR,
  CANCELACION_VALIDACANCELA,
  CANCELACION_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

export const cancelacionReset = () => (dispatch) => {
  dispatch({
    type: CANCELACION_RESET,
  });
};

// ID PACIENTE FAMILIAR = idPF
export const wsGetValidaCancelacion = (idTurno, idPF) => (dispatch) => {
  axiosLogin(null, "darTurnos").then((respuesta) => {
    respuesta
      .get(`his/turnos/validaCancelacion/${idTurno}/${idPF ? idPF : -1}`)
      .then((res) => {
        dispatch({
          type: CANCELACION_VALIDACANCELA,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: CANCELACION_ERROR,
          payload: error,
        });
      });
  });
};
/* // ID PACIENTE FAMILIAR = idPF
export const wsGetValidaCancelacion = (idTurno, idPF) => (dispatch) => {
  axiosInstance(null, "darTurnos").then((respuesta) => {
    respuesta
      .get(`/turnos/validaCancelacion/${idTurno}/${!idPF ? "" : idPF}`)
      .then((res) => {
        dispatch({
          type: CANCELACION_VALIDACANCELA,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: CANCELACION_ERROR,
          payload: error,
        });
      });
  });
}; */

/* export const wsGetValidaCancelacionLabo = (idTurno, idPF) => (dispatch) => {
 axiosInstance(null, "darTurnos").then(respuesta => {
  respuesta
  .get(`/laboratorio/validaCancelacion/${idTurno}/${!idPF ? '':idPF}`)
  .then((res) => {
    dispatch({
      type: CANCELACION_VALIDACANCELA,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: CANCELACION_ERROR,
      payload: error,
    });
  });
 } )
}; */
export const wsGetValidaCancelacionLabo = (idTurno, idPF) => (dispatch) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/validaCancelacion/${idTurno}/${!idPF ? "" : idPF}`)
      .then((res) => {
        dispatch({
          type: CANCELACION_VALIDACANCELA,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: CANCELACION_ERROR,
          payload: error,
        });
      });
  });
};

/* // ID PACIENTE FAMILIAR ? idPF
export const wsDeleteTurno =
  (idTurno, idMotivo, motivoOtro, idPF, lugarInicio) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .delete(
          `/turnos/cancelar/${idTurno}/${idMotivo}/${motivoOtro}/${
            !idPF ? "" : idPF
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
            adicional: !lugarInicio ? false : lugarInicio,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  }; */
// ID PACIENTE FAMILIAR ? idPF
export const wsDeleteTurno =
  (idTurno, idMotivo, motivoOtro, idPF, lugarInicio) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .delete(
          `his/turnos/Cancelar/${idTurno}/${idMotivo}/${motivoOtro}/${
            idPF ? idPF : -1
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
            adicional: !lugarInicio ? false : lugarInicio,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };

// ID PACIENTE FAMILIAR = idPF
export const wsDeleteTurnolaboratorio =
  (idTurno, idMotivo, otroMotivo, idPF) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosLogin(null, "darTurnos").then((respuesta) => {
      respuesta
        .delete(
          `/lis/laboratorio/Cancelar/${idTurno}/${idMotivo}/${otroMotivo}/${
            idPF ? idPF : -1
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };
/* // ID PACIENTE FAMILIAR = idPF
export const wsDeleteTurnolaboratorio =
  (idTurno, idMotivo, otroMotivo, idPF) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance(null, "darTurnos").then((respuesta) => {
      respuesta
        .delete(
          `/laboratorio/cancelar/${idTurno}/${idMotivo}/${otroMotivo}/${
            !idPF ? "" : idPF
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  }; */

export const wsDeleteTurnoSesionKinesio =
  (idSesion, idcanc, motivoOtro, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosLogin(null, "darTurnos").then((respuesta) => {
      respuesta
        .delete(
          `his/turnos/CancelarSesion/${idSesion}/${idcanc}/${motivoOtro}/${
            idPacFamiliar ? idPacFamiliar : -1
          }`
        )
        .then((res) => {
          dispatch({ type: CANCELACION_SUCCESS, payload: res.data });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  };
/* export const wsDeleteTurnoSesionKinesio =
  (idSesion, idcanc, motivoOtro, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: CANCELACION_LOADING,
    });

    axiosInstance(null, "darTurnos").then((respuesta) => {
      respuesta
        .delete(
          `/turnos/CancelarSesion/${idSesion}/${idcanc}/${motivoOtro}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((res) => {
          dispatch({
            type: CANCELACION_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CANCELACION_ERROR,
            payload: error,
          });
        });
    });
  }; */
